'use client';

import { showDoNotSell } from 'osano/components';
import React from 'react';

interface LinkObject {
    id?: string | null;
    title: string;
    url: string;
    // When true, the link opens Osano's "Do Not Sell" modal instead of navigating.
    osanoDoNotSell?: boolean;
}

interface LinkGroup {
    title: string;
    groupClass?: string;
    links: LinkObject[];
}

interface SiteFooterLinkProps {
    linkGroup: LinkGroup;
}

const FooterLink: React.FC<{ link: LinkObject }> = ({ link }) => {
    if (link.osanoDoNotSell) {
        return (
            <a
                href={link.url}
                onClick={(event) => {
                    event.preventDefault();
                    showDoNotSell();
                }}
            >
                {link.title}
            </a>
        );
    }

    return <a href={link.url}>{link.title}</a>;
};

const SiteFooterLink: React.FC<SiteFooterLinkProps> = ({ linkGroup }) => (
    <div className={linkGroup.groupClass}>
        <div className="pb-2">
            <b role="heading" aria-level={2}>
                {linkGroup.title}
            </b>
        </div>
        <ul className="text-sm space-y-3">
            {linkGroup.links.map((link, index) => (
                <li key={index}>
                    <FooterLink link={link} />
                </li>
            ))}
        </ul>
    </div>
);

export default SiteFooterLink;
